import { render } from "./Sidebar.vue?vue&type=template&id=c30be8d8&bindings={}"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script